import { render, staticRenderFns } from "./ReportTest.vue?vue&type=template&id=2cfad0b0"
import script from "./ReportTest.vue?vue&type=script&lang=js"
export * from "./ReportTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports